module.exports = __webpack_public_path__ + "static/media/refreshIcon.9c2a29af.svg";